import { render, staticRenderFns } from "./order_query.vue?vue&type=template&id=5b144890&scoped=true&"
import script from "./order_query.vue?vue&type=script&lang=js&"
export * from "./order_query.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b144890",
  null
  
)

export default component.exports